export const InputSize = Object.freeze({
	Lg: 'l',
	Md: 'm',
	Sm: 's',
});

export const InputDesign = Object.freeze({
	Primary: 'primary',
	Grey: 'grey',
	LightGrey: 'light-grey',
	Disabled: 'disabled',
	Naked: 'naked',
});
